import Lang from 'Lang/General'

export const StatusOptions = lang => [
  {
    value: 'INTERESTED',
    label: Lang['INTERESTED'][lang]
  },
  {
    value: 'CONFIRMED',
    label: Lang['CONFIRMED'][lang]
  },
  {
    value: 'INACTIVE',
    label: Lang['INACTIVE'][lang]
  }
]

export const CreateFormData = (industries, lang, fairs, formData) => [
  {
    value: 'company_name',
    label: 'COMPANY_NAME',
    type: 'text',
    required: true,
    col: 6
  },
  {
    value: 'short_company_name',
    required: true,
    label: 'SHORT_TITLE',
    type: 'text',
    col: 6
  },

  {
    value: 'role',
    label: 'ROLE',
    required: true,
    type: 'select',
    options: [
      {
        value: 'SPEAKER',
        label: Lang['SPEAKER'][lang]
      },
      {
        value: 'EXHIBITOR',
        label: Lang['EXHIBITOR'][lang]
      },
      {
        value: 'CONSULTANT',
        label: Lang['CONSULTANT'][lang]
      }
    ],
    col: 6
  },
  {
    value: 'status',
    required: true,
    label: 'STATUS',
    type: 'select',
    options: StatusOptions(lang),
    col: 6
  },
  ... formData.status === 'CONFIRMED' ? [
    {
      value: 'fairs',
      required: true,
      label: 'FAIRS',
      type: 'react-select',
      placeholder: 'SELECT_FAIR',
      multiple: true,
      options: fairs,
      col: 6
    },
  ] : [],
  {
    value: 'industries',
    required: true,
    placeholder: 'SELECT_INDUSTRY',
    label: 'INDUSTRIES',
    type: 'react-select',
    multiple: true,
    options: industries,
    col: 6
  },
  {

    value: 'email',
    label: 'EMAIL_ADDRESS',
    type: 'text',
    col: 6
  },
  {

    value: 'username',
    label: 'USER_NAME',
    disabled: true,
    type: 'text',
    col: 6
  },
  {
    value: 'language',
    required: true,
    label: 'LANGUAGE',
    type: 'select',
    options: [
      {
        value: 'en',
        label: Lang['ENGLISH'][lang]
      },
      {
        value: 'de',
        label: Lang['GERMAN'][lang]
      },
      // {
      //   value: 'nl',
      //   label: 'Dutch'
      // },
      // {
      //   value: 'it',
      //   label: 'Italy'
      // }
    ],
    col: 6
  }
]

export const CompanyDataFormData = (countries, lang, formData, industries, fairs) =>[
  {
    value: 'company_name',
    label: 'COMPANY_NAME',
    type: 'text',
    required: true,
    col: 6
  },
  {
    value: 'short_company_name',
    required: true,
    label: 'SHORT_TITLE',
    type: 'text',
    col: 6
  },
  ... formData.role !== 'SPEAKER' ? [
    {
      value: 'slugs',
      required: true,
      label: 'SLUG',
      type: 'text',
      col: 6
    }
  ] : [],
  {
    value: 'role',
    label: 'ROLE',
    required: true,
    type: 'select',
    options: [
      {
        value: 'SPEAKER',
        label: Lang['SPEAKER'][lang]
      },
      {
        value: 'EXHIBITOR',
        label: Lang['EXHIBITOR'][lang]
      },
      {
        value: 'CONSULTANT',
        label: Lang['CONSULTANT'][lang]
      }
    ],
    col: 6
  },
  ... formData.role === 'CONSULTANT' ? [
    {
    
      value: 'is_also_speaker',
      required: true,
      className: 'd-flex align-items-center mb-2',
      label: 'IS_ALSO_SPEAKER',
      type: 'checkbox',
      col: 3
    },
    {
      value: 'is_multiple_brands',
      required: true,
      className: 'd-flex align-items-center mb-2',
      label: 'IS_MULTI_BRANDS',
      type: 'checkbox',
      col: 3
    }
  ] : [],
  ... formData.role === 'EXHIBITOR' ? [
    {
    
      value: 'is_also_speaker',
      required: true,
      className: 'd-flex align-items-center mb-2',
      label: 'IS_ALSO_SPEAKER',
      type: 'checkbox',
      col: 2
    },
    {
      value: 'is_multiple_brands',
      required: true,
      className: 'd-flex align-items-center mb-2',
      label: 'IS_MULTI_BRANDS',
      type: 'checkbox',
      col: 2
    },
    {
      value: 'is_newcomer',
      required: false,
      className: 'd-flex align-items-center mb-2',
      label: 'IS_NEWCOMER',
      type: 'checkbox',
      col: 2
    }
  ] : [],
  {
    value: 'status',
    required: true,
    label: 'STATUS',
    type: 'select',
    options: StatusOptions(lang),
    col: 6
  },
  ... formData.status === 'CONFIRMED' ? [
    {
      value: 'fairs',
      required: true,
      label: 'FAIRS',
      placeholder: 'SELECT_FAIR',
      type: 'react-select',
      multiple: true,
      options: fairs,
      col: 6
    },
  ] : [],
  {
    value: 'industries',
    required: true,
    placeholder: 'SELECT_INDUSTRY',
    label: 'INDUSTRIES',
    type: 'react-select',
    multiple: true,
    options: industries,
    col: 6
  },
  {

    value: 'email',
    label: 'EMAIL_ADDRESS',
    type: 'text',
    col: 6
  },
  {
    value: 'street',
    label: 'STREET',
    type: 'text',
    col: 6
  },
  {
    value: 'house_number',
    label: 'HOUSE_NUMBER',
    type: 'text',
    col: 6
  },
  {
    value: 'zip_code',
    label: 'ZIP_CODE',
    type: 'text',
    col: 6
  },
  {
    value: 'city',
    label: 'CITY',
    type: 'text',
    col: 6
  },
  {
    value: 'country',
    label: 'COUNTRY',
    placeholder: 'SELECT_COUNTRY',
    type: 'react-select',
    options: countries,
    col: 6
  },
  {
    value: 'uid_number',
    required: false,
    label: 'UID_NUMBER',
    type: 'text',
    col: 6
  },
  {
    value: 'language',
    required: true,
    label: 'LANGUAGE',
    type: 'select',
    options: [
      {
        value: 'en',
        label: Lang['ENGLISH'][lang]
      },
      {
        value: 'de',
        label: Lang['GERMAN'][lang]
      },
    ],
    col: 6
  },
  {
    value: 'notice',
    label: 'NOTICE',
    type: 'textarea',
    col: 12
  },
]

export const SocialMediaData = [ 
  {
    value: 'facebook',
    label: 'FACEBOOK',
    type: 'text',
    col: 6
  },
  {
    value: 'instagram',
    label: 'INSTRAGRAM',
    type: 'text',
    col: 6
  },
  {
    value: 'linkedin',
    label: 'LINKEDIN',
    type: 'text',
    col: 6
  },
  {
    value: 'youtube',
    label: 'YOUTUBE',
    type: 'text',
    col: 6
  }
]


export const PersonalFormData = lang => [
  {
    value: 'salutation',
    label: 'SALUTATION',
    type: 'select',
    options: [
      {
        value: 'Mrs',
        label: Lang['MRS'][lang]
      },
      {
        value: 'Mr',
        label: Lang['MR'][lang]
      },
      {
        value: 'Diverse',
        label: Lang['DIVERSE'][lang]
      }
    ],
    col: 6
  },
  {
    value: 'position',
    label: 'POSITION',
    type: 'text',
    col: 6
  },
  {
    value: 'first_name',
    label: 'FIRST_NAME',
    type: 'text',
    col: 6
  },
  {
    value: 'last_name',
    label: 'LAST_NAME',
    type: 'text',
    col: 6
  },
  {
    value: 'phone',
    label: 'PHONE',
    type: 'text',
    col: 6
  },
  {
    value: 'mobile_phone',
    label: 'MOBILE',
    type: 'text',
    col: 6
  }
]

export const ContactPersonFormData = [
  {
    value: 'marketing_name',
    label: 'MARKETING_NAME',
    type: 'text',
    col: 6
  },
  {
    value: 'marketing_email',
    label: 'MARKETING_EMAIL',
    type: 'text',
    col: 6
  },
  {
    value: 'other_name',
    required: false,
    label: 'OTHER_NAME',
    type: 'text',
    col: 6
  },
  {
    value: 'other_email_address_or_phone',
    required: false,
    label: 'OTHER_EMAIL_PHONE',
    type: 'text',
    col: 6
  }
]

export const InvoiceFormData = countries => [
  {
    value: 'company_name_invoice',
    label: 'COMPANY_NAME_INVOICE',
    value_to_copy: 'company_name',
    label_to_copy: 'COMPANY_NAME',
    type: 'text',
    col: 6
  },
  {
    value: 'street_invoice',
    label: 'STREET_INVOICE',
    type: 'text',
    value_to_copy: 'street',
    label_to_copy: 'STREET',
    col: 6
  },
  {
    value: 'house_number_invoice',
    label: 'HOUSE_NUMBER_INVOICE',
    value_to_copy: 'house_number',
    label_to_copy: 'HOUSE_NUMBER',
    type: 'text',
    col: 6
  },
  {
    value: 'zip_code_invoice',
    label: 'ZIP_CODE_INVOICE',
    value_to_copy: 'zip_code',
    label_to_copy: 'ZIP_CODE',
    type: 'text',
    col: 6
  },
  {
    value: 'city_invoice',
    label: 'CITY_INVOICE',
    value_to_copy: 'city',
    label_to_copy: 'CITY',
    type: 'text',
    col: 6
  },
  {
    value: 'country_invoice',
    label: 'COUNTRY_INVOICE',
    value_to_copy: 'country',
    label_to_copy: 'COUNTRY',
    type: 'react-select',
    options: countries,
    col: 6
  },
  
  {
    value: 'phone_invoice',
    label: 'PHONE_INVOICE',
    value_to_copy: 'phone',
    label_to_copy: 'PHONE',
    type: 'text',
    col: 6
  },
  {
    value: 'email_invoice',
    label: 'EMAIL_INVOICE',
    value_to_copy: 'email',
    label_to_copy: 'EMAIL',
    type: 'text',
    col: 6
  },
  {
    value: 'vat_num_invoice',
    label: 'VAT_NUM_INVOICE',
    value_to_copy: 'uid_number',
    label_to_copy: 'UID_NUMBER',
    type: 'text',
    col: 6
  }
]


export const FormSampleData = {
  company_name: '',
  short_company_name: '',
  slugs: '',
  role: 'SPEAKER',
  status: 'INTERESTED',
  street: "",
  house_number: "",
  zip_code: '',
  city: '',
  country: '',
  facebook: '',
  instagram: '',
  linkedin: '',
  youtube: '',
  salutation: '',
  position: '',
  first_name: '',
  last_name: '',
  phone: '',
  mobile_phone: '',
  marketing_name: '',
  marketing_email: '',
  other_name: '',
  other_email_address_or_phone: '',
  technical_name: '',
  email: '',
  uid_number: '',
  username: '',
  password: '',
  notice: '',
  client_id: null,

  is_also_speaker: false,
  is_multiple_brands: false,
  is_newcomer: false,

  street_invoice: '',
  house_number_invoice: "",
  company_name_invoice: '',
  zip_code_invoice: '',
  city_invoice: '',
  country_invoice: '',
  phone_invoice: '',
  email_invoice: '',
  vat_num_invoice: '',
  industries: [],
  fairs: [],
  language: 'de',
  is_invoice_identical: true
}

export const FormTabData = [
  {
    value: 'company_data',
    label: 'COMPANY_DATA'
  }, 
  {
    value: 'personal_data',
    label: 'PERSONAL_DATA' 
  },
  {
    value: 'contact_person',
    label: 'CONTACT_PERSON' 
  },
  {
    value: 'social_media',
    label: 'SOCIAL_MEDIA' 
  },
  {
    value: 'for_invoice',
    label: 'FOR_INVOICE'
  }
]

export const TrafficLightTooltip = {
  has_master_data: 'HAS_MASTER_DATA',
  has_matchmaking : 'HAS_MATCHMAKING',
  has_fairpass_data: 'HAS_FAIRPASS_DATA',
  has_booking: 'HAS_BOOKING',
  has_uploads: 'HAS_UPLOADS'
}

export const SearchParams = (props) => [
  {
    label: Lang[ 'COMPANY' ][ props.data.languageReducer.userSettings.admin_panel_language],
    col: 6,
    value: 'company_name',
    param: ''
  },
  {
    label: Lang[ 'STATUS' ][ props.data.languageReducer.userSettings.admin_panel_language],
    value: 'status',
    col: 6,
    param: '',
    exact: true,
    type: 'select',
    options: [
      {
        id: 'CONFIRMED',
        name: Lang[ 'CONFIRMED' ][ props.data.languageReducer.userSettings.admin_panel_language]
      },
      {
        id: 'INTERESTED',
        name: Lang[ 'INTERESTED' ][ props.data.languageReducer.userSettings.admin_panel_language]
      },
      {
        id: 'INACTIVE',
        name: Lang[ 'INACTIVE' ][ props.data.languageReducer.userSettings.admin_panel_language]
      }
    ]
  },
  {
    label: '',
    value: 'role',
    col: 12,
    param: [],
    type: 'checkbox',
    options: [
      {
        id: 'EXHIBITOR',
        name: Lang[ 'EXHIBITOR' ][ props.data.languageReducer.userSettings.admin_panel_language]
      },
      {
        id: 'SPEAKER',
        name: Lang[ 'SPEAKER' ][ props.data.languageReducer.userSettings.admin_panel_language]
      },
      {
        id: 'CONSULTANT',
        name: Lang[ 'CONSULTANT' ][ props.data.languageReducer.userSettings.admin_panel_language]
      }
    ]
  },
]